export enum UpdateStatusEnum {
  Pilot = 0,
  Production = 1,
  Inactive = 2
}